
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Import FontAwesomeIcon
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"; // Import specific icon
// import "./Sideboard.css"; // Add styles for dropdown

// const Sideboard = ({ employees, groups, onSelectChat }) => {
//   const [showGroups, setShowGroups] = useState(false);
//   const [showIndividualChats, setShowIndividualChats] = useState(false);
//   const navigate = useNavigate(); // Initialize useNavigate

//   // Toggle function for groups dropdown
//   const toggleGroups = () => {
//     setShowGroups((prev) => !prev);
//     if (!showGroups) {
//       navigate("/groupchatboard"); // Navigate to groupchatboard if groups dropdown is clicked
//     }
//   };

//   // Toggle function for individual chats dropdown
//   const toggleIndividualChats = () => {
//     setShowIndividualChats((prev) => !prev);
//     if (!showIndividualChats) {
//       navigate("/chatboard"); // Navigate to chatboard if direct messages dropdown is clicked
//     }
//   };

//   // Handle back button click
//   const handleBackClick = () => {
//     navigate("/EmployeeDashboard"); // Redirect to EmployeeDashboard
//   };

//   return (
//     <div className="sideboard-container">
//       {/* Back Button with FontAwesome Arrow */}
//       <button className="back-button" onClick={handleBackClick}>
//         <FontAwesomeIcon icon={faArrowLeft} className="back-arrow" /> Back
//       </button>

//       <h2>
//         <u>Chats</u>
//       </h2>

//       <div className="dropdown">
//         <div className="dropdown-heading" onClick={toggleIndividualChats}>
//           <span>Direct Messages</span>
//           <span className={`arrow ${showIndividualChats ? "up" : "down"}`}>
//             ⬇️
//           </span>
//         </div>
//         {showIndividualChats && (
//           <div className="dropdown-content">
//             {employees.map((employee) => (
//               <div
//                 key={employee._id}
//                 className="chat-item"
//                 onClick={() => onSelectChat(employee._id)}
//               >
//                 <span>{employee.name}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Groups Dropdown */}
//       <div className="dropdown">
//         <div className="dropdown-heading" onClick={toggleGroups}>
//           <span>Groups</span>
//           <span className={`arrow ${showGroups ? "up" : "down"}`}>⬇️</span>
//         </div>
//         {showGroups && (
//           <div className="dropdown-content">
//             {groups.length > 0 ? (
//               groups.map((group) => (
//                 <div
//                   key={group._id}
//                   className="chat-item"
//                   onClick={() => onSelectChat(group._id)}
//                 >
//                   <span>{group.name}</span>
//                 </div>
//               ))
//             ) : (
//               <p>No groups available</p> // Handle empty state
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Sideboard;




//////////////////////////////


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Avatar,
  InputBase,
  IconButton,
  Badge,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import GroupsIcon from "@mui/icons-material/Groups";

const Sideboard = ({ employees, groups, onSelectChat, selectedChatId }) => {
  const [showGroups, setShowGroups] = useState(true);
  const [showIndividualChats, setShowIndividualChats] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const toggleGroups = () => {
    setShowGroups((prev) => !prev);
  };

  const toggleIndividualChats = () => {
    setShowIndividualChats((prev) => !prev);
  };

  const handleBackClick = () => {
    navigate("/EmployeeDashboard");
  };

  const filteredEmployees = employees.filter((emp) =>
    emp.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredGroups = groups.filter((grp) =>
    (grp.name || grp.groupName || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#fff",
        overflow: "hidden",
      }}
    >
      {/* ===== Header ===== */}
      <Box
        sx={{
          px: 2,
          pt: 2.5,
          pb: 1.5,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton
              onClick={handleBackClick}
              size="small"
              sx={{
                color: "#fff",
                "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: "1.25rem", letterSpacing: "-0.01em" }}
            >
              Chats
            </Typography>
          </Box>
        </Box>

        {/* Search Bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "rgba(255,255,255,0.18)",
            borderRadius: "12px",
            px: 1.5,
            py: 0.5,
            backdropFilter: "blur(8px)",
          }}
        >
          <SearchIcon sx={{ color: "rgba(255,255,255,0.7)", fontSize: 20, mr: 1 }} />
          <InputBase
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{
              flex: 1,
              color: "#fff",
              fontSize: "0.85rem",
              "& ::placeholder": { color: "rgba(255,255,255,0.6)", opacity: 1 },
            }}
          />
        </Box>
      </Box>

      {/* ===== Contact List ===== */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          "&::-webkit-scrollbar": { width: "4px" },
          "&::-webkit-scrollbar-thumb": {
            background: "#d0d5dd",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": { background: "#b0b5bd" },
        }}
      >
        {/* ---- Direct Messages Section ---- */}
        <Box sx={{ mt: 1 }}>
          <ListItemButton
            onClick={toggleIndividualChats}
            sx={{
              py: 0.8,
              px: 2,
              "&:hover": { bgcolor: "transparent" },
            }}
          >
            <ChatBubbleOutlineIcon
              sx={{ fontSize: 18, color: "#667eea", mr: 1 }}
            />
            <ListItemText
              primary="Direct Messages"
              primaryTypographyProps={{
                fontWeight: 700,
                fontSize: "0.75rem",
                color: "#667eea",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
              }}
            />
            <Typography sx={{ color: "#667eea", fontSize: 18 }}>
              {showIndividualChats ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </Typography>
          </ListItemButton>
          <Collapse in={showIndividualChats} timeout="auto" unmountOnExit>
            <List
              component="div"
              disablePadding
              sx={{
                maxHeight: "calc(50vh - 120px)",
                overflowY: "auto",
                "&::-webkit-scrollbar": { width: "4px" },
                "&::-webkit-scrollbar-thumb": {
                  background: "#d0d5dd",
                  borderRadius: "10px",
                },
              }}
            >
              {filteredEmployees.map((employee) => {
                const isSelected = selectedChatId === employee._id;
                return (
                  <ListItemButton
                    key={employee._id}
                    onClick={() => onSelectChat(employee._id)}
                    sx={{
                      py: 1.2,
                      px: 2,
                      borderLeft: isSelected
                        ? "3px solid #667eea"
                        : "3px solid transparent",
                      bgcolor: isSelected
                        ? "rgba(102,126,234,0.08)"
                        : "transparent",
                      "&:hover": {
                        bgcolor: isSelected
                          ? "rgba(102,126,234,0.12)"
                          : "rgba(0,0,0,0.03)",
                      },
                      transition: "all 0.15s ease",
                    }}
                  >
                    <Badge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="dot"
                      sx={{
                        mr: 1.5,
                        "& .MuiBadge-badge": {
                          bgcolor: "#44b700",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          border: "2px solid #fff",
                        },
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          background:
                            "linear-gradient(135deg, #667eea, #764ba2)",
                          fontSize: "0.95rem",
                          fontWeight: 600,
                        }}
                      >
                        {employee.name?.charAt(0).toUpperCase()}
                      </Avatar>
                    </Badge>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: isSelected ? 700 : 600,
                            fontSize: "0.9rem",
                            color: "#1a1a2e",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {employee.name}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#8b8fa3",
                          fontSize: "0.78rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          mt: 0.2,
                        }}
                      >
                        {employee.designation || "Team Member"}
                      </Typography>
                    </Box>
                  </ListItemButton>
                );
              })}
              {filteredEmployees.length === 0 && (
                <Typography
                  variant="body2"
                  sx={{ px: 3, py: 2, color: "#8b8fa3", textAlign: "center" }}
                >
                  No contacts found
                </Typography>
              )}
            </List>
          </Collapse>
        </Box>

        {/* ---- Groups Section ---- */}
        <Box sx={{ mt: 0.5 }}>
          <ListItemButton
            onClick={toggleGroups}
            sx={{
              py: 0.8,
              px: 2,
              "&:hover": { bgcolor: "transparent" },
            }}
          >
            <GroupsIcon sx={{ fontSize: 18, color: "#764ba2", mr: 1 }} />
            <ListItemText
              primary="Groups"
              primaryTypographyProps={{
                fontWeight: 700,
                fontSize: "0.75rem",
                color: "#764ba2",
                textTransform: "uppercase",
                letterSpacing: "0.06em",
              }}
            />
            <Typography sx={{ color: "#764ba2", fontSize: 18 }}>
              {showGroups ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </Typography>
          </ListItemButton>
          <Collapse in={showGroups} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {filteredGroups.length > 0 ? (
                filteredGroups.map((group) => {
                  const groupName = group.name || group.groupName || "Group";
                  const isSelected = selectedChatId === group._id;
                  return (
                    <ListItemButton
                      key={group._id}
                      onClick={() => onSelectChat(group._id)}
                      sx={{
                        py: 1.2,
                        px: 2,
                        borderLeft: isSelected
                          ? "3px solid #764ba2"
                          : "3px solid transparent",
                        bgcolor: isSelected
                          ? "rgba(118,75,162,0.08)"
                          : "transparent",
                        "&:hover": {
                          bgcolor: isSelected
                            ? "rgba(118,75,162,0.12)"
                            : "rgba(0,0,0,0.03)",
                        },
                        transition: "all 0.15s ease",
                      }}
                    >
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          mr: 1.5,
                          background:
                            "linear-gradient(135deg, #764ba2, #667eea)",
                          fontSize: "0.95rem",
                          fontWeight: 600,
                        }}
                      >
                        {groupName.charAt(0).toUpperCase()}
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography
                          sx={{
                            fontWeight: isSelected ? 700 : 600,
                            fontSize: "0.9rem",
                            color: "#1a1a2e",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {groupName}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#8b8fa3",
                            fontSize: "0.78rem",
                            mt: 0.2,
                          }}
                        >
                          Group chat
                        </Typography>
                      </Box>
                    </ListItemButton>
                  );
                })
              ) : (
                <Typography
                  variant="body2"
                  sx={{ px: 3, py: 2, color: "#8b8fa3", textAlign: "center" }}
                >
                  No groups available
                </Typography>
              )}
            </List>
          </Collapse>
        </Box>
      </Box>
    </Box>
  );
};

export default Sideboard;
